module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "academic-landing"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('section', {
    staticClass: "section devices m-b-0"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "text-center tabsAct m-b-lg"
  }, [_c('ul', {
    staticClass: "list-inline text-center",
    attrs: {
      "role": "tablist"
    }
  }, [_c('li', {
    class: {
      active: _vm.activeTab === 1
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        _vm.activeTab = 1
      }
    }
  }, [_vm._m(5)]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.activeTab === 2
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        _vm.activeTab = 2
      }
    }
  }, [_vm._m(6)]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.activeTab === 3
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        _vm.activeTab = 3
      }
    }
  }, [_vm._m(7)])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane",
    class: {
      active: _vm.activeTab === 1
    },
    attrs: {
      "role": "tabpanel",
      "id": "android"
    }
  }, [_vm._m(11)]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    class: {
      active: _vm.activeTab === 2
    },
    attrs: {
      "role": "tabpanel",
      "id": "ios"
    }
  }, [_vm._m(15)]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    class: {
      active: _vm.activeTab === 3
    },
    attrs: {
      "role": "tabpanel",
      "id": "pc"
    }
  }, [_vm._m(19), _vm._v(" "), _vm._m(20)])])])]), _vm._v(" "), _vm._m(21)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section intro"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-5 white text-center text-sm-left"
  }, [_c('h1', {
    staticClass: "m-t-0 m-b-lg"
  }, [_vm._v("A logbook and electronic portfolio for Academic Registrars, Supervisors and Heads of Departments")]), _vm._v(" "), _c('div', {
    staticClass: "m-b"
  }, [_c('app-links', {
    attrs: {
      "appLinks": _vm.links
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "m-b-lg"
  }, [_vm._v("Approved by the Colleges of Medicine South Africa")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section p-y-md"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 text-center"
  }, [_c('h3', {
    staticClass: "m-t-0"
  }, [_vm._v("Supported Specialities")]), _vm._v(" "), _c('div', {
    staticClass: "label-tags text-center m-y-lg"
  }, _vm._l((_vm.specialities), function(speciality, idx) {
    return _c('div', {
      key: idx
    }, [_vm._v("\n              " + _vm._s(speciality) + "\n            ")])
  }), 0), _vm._v(" "), _c('p', {
    staticClass: "m-b-0"
  }, [_vm._v("More Specialities coming soon...")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row m-b-lg"
  }, [_c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('h2', [_vm._v("LogBox Academic Benefits")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 text-left"
  }, [_c('ul', {
    staticClass: "feature-list icon-left"
  }, [_c('li', [_c('i', {
    staticClass: "fa fa-university"
  }), _vm._v(" "), _c('h3', [_vm._v("Integrate with your"), _c('br'), _vm._v("academic institution")]), _vm._v(" "), _c('p', [_vm._v("Endorsed by the Colleges of Medicine of South Africa and links directly to your training institution.")])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" "), _c('h3', [_vm._v("CV and Academic"), _c('br'), _vm._v("training history")]), _vm._v(" "), _c('p', [_vm._v("Record your academic progress in a well structured format.")])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-pencil-square-o"
  }), _vm._v(" "), _c('h3', [_vm._v("Sign off your"), _c('br'), _vm._v("rotations electronically")]), _vm._v(" "), _c('p', [_vm._v("Supervisors and Heads of Departments can electronically approve your rotations.")])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-lock"
  }), _vm._v(" "), _c('h3', [_vm._v("Absolute"), _c('br'), _vm._v("Privacy")]), _vm._v(" "), _c('p', [_vm._v("Feel secure by setting up either a unique code or setup biometric access.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 text-center hidden-xs"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": require("assets/images/splash-main6.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 text-left"
  }, [_c('ul', {
    staticClass: "feature-list icon-left"
  }, [_c('li', [_c('i', {
    staticClass: "fa fa-file"
  }), _vm._v(" "), _c('h3', [_vm._v("Logbook"), _c('br'), _vm._v("Reports")]), _vm._v(" "), _c('p', [_vm._v("Easily export your de-identified procedure reports to Excel and PDF documents.")])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-cloud-upload"
  }), _vm._v(" "), _c('h3', [_vm._v("Upload Procedure"), _c('br'), _vm._v("Photos")]), _vm._v(" "), _c('p', [_vm._v("Upload your photos and file them with the relevant procedure.")])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-wifi"
  }), _vm._v(" "), _c('h3', [_vm._v("Online & Offline"), _c('br'), _vm._v("Access")]), _vm._v(" "), _c('p', [_vm._v("Log your procedures even when you aren't connected to the internet.")])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-cloud"
  }), _vm._v(" "), _c('h3', [_vm._v("1GB Free"), _c('br'), _vm._v("Cloud Storage")]), _vm._v(" "), _c('p', [_vm._v("Safe and reliable backup that is accessible from anywhere.")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section benefits"
  }, [_vm._m(2)])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row m-b-l"
  }, [_c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('h2', {
    staticClass: "m-t-0 m-b-lg"
  }, [_vm._v("LogBox Academic works on all devices")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-default btn-lg",
    attrs: {
      "href": "#android",
      "data-toggle": "tab",
      "aria-expanded": "true"
    }
  }, [_c('i', {
    staticClass: "fa fa-android fa-2x"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-default btn-lg",
    attrs: {
      "href": "#ios",
      "data-toggle": "tab",
      "aria-expanded": "false"
    }
  }, [_c('i', {
    staticClass: "fa fa-apple fa-2x"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-default btn-lg",
    attrs: {
      "href": "#pc",
      "data-toggle": "tab",
      "aria-expanded": "false"
    }
  }, [_c('i', {
    staticClass: "fa fa-desktop fa-2x"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-4 text-center"
  }, [_c('h3', [_vm._v("Secure Access")]), _vm._v(" "), _c('p', {
    staticClass: "m-b-lg"
  }, [_vm._v("Keep your details as well as the details of your patients private by logging in securely.")]), _vm._v(" "), _c('img', {
    staticClass: "img-responsive center-block",
    attrs: {
      "src": require("assets/images/brochure/academic/1.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-4 text-center"
  }, [_c('h3', [_vm._v("Procedure Logbook")]), _vm._v(" "), _c('p', {
    staticClass: "m-b-lg"
  }, [_vm._v("Log and review all of your procedures in the list overview section.")]), _vm._v(" "), _c('img', {
    staticClass: "img-responsive center-block",
    attrs: {
      "src": require("assets/images/brochure/academic/2.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-4 text-center"
  }, [_c('h3', [_vm._v("Comprehensive Information")]), _vm._v(" "), _c('p', {
    staticClass: "m-b-lg"
  }, [_vm._v("View a comprehensive detailed overview of your past procedures.")]), _vm._v(" "), _c('img', {
    staticClass: "img-responsive center-block",
    attrs: {
      "src": require("assets/images/brochure/academic/3.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10)])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-4 text-center"
  }, [_c('h3', [_vm._v("Secure Access")]), _vm._v(" "), _c('p', {
    staticClass: "m-b-lg"
  }, [_vm._v("Keep your details as well as the details of your patients private by logging in securely.")]), _vm._v(" "), _c('img', {
    staticClass: "img-responsive center-block",
    attrs: {
      "src": require("assets/images/brochure/academic/4.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-4 text-center"
  }, [_c('h3', [_vm._v("Procedure Logbook")]), _vm._v(" "), _c('p', {
    staticClass: "m-b-lg"
  }, [_vm._v("Log and review all of your procedures in the list overview section.")]), _vm._v(" "), _c('img', {
    staticClass: "img-responsive center-block",
    attrs: {
      "src": require("assets/images/brochure/academic/5.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-4 text-center"
  }, [_c('h3', [_vm._v("Comprehensive Information")]), _vm._v(" "), _c('p', {
    staticClass: "m-b-lg"
  }, [_vm._v("View a comprehensive detailed overview of your past procedures.")]), _vm._v(" "), _c('img', {
    staticClass: "img-responsive center-block",
    attrs: {
      "src": require("assets/images/brochure/academic/6.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_vm._m(12), _vm._v(" "), _vm._m(13), _vm._v(" "), _vm._m(14)])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-4 text-center"
  }, [_c('h3', [_vm._v("Secure Access")]), _vm._v(" "), _c('p', {
    staticClass: "m-b-lg"
  }, [_vm._v("Keep your details as well as the details of your patients private by logging in securely.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-4 text-center"
  }, [_c('h3', [_vm._v("Procedure Logbook")]), _vm._v(" "), _c('p', {
    staticClass: "m-b-lg"
  }, [_vm._v("Log and review all of your procedures in the list overview section.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-4 text-center"
  }, [_c('h3', [_vm._v("Comprehensive Information")]), _vm._v(" "), _c('p', {
    staticClass: "m-b-lg"
  }, [_vm._v("View a comprehensive detailed overview of your past procedures.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_vm._m(16), _vm._v(" "), _vm._m(17), _vm._v(" "), _vm._m(18)])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('img', {
    staticClass: "img-responsive center-block",
    attrs: {
      "src": require("assets/images/brochure/academic/screen10.png")
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {}, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row flush"
  }, [_c('div', {
    staticClass: "col-md-4 grey-1"
  }, [_c('div', {
    staticClass: "p-a-lg"
  }, [_c('h3', {
    staticClass: "m-t-0 m-b"
  }, [_vm._v("LogBox Patient")]), _vm._v(" "), _c('p', {}, [_vm._v("LogBox allows you to share your information with your healthcare professional securely. No more paper forms needed.")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-default",
    attrs: {
      "to": "/patient"
    }
  }, [_vm._v("Learn More")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 grey-2"
  }, [_c('div', {
    staticClass: "p-a-lg"
  }, [_c('h3', {
    staticClass: "m-t-0 m-b"
  }, [_vm._v("LogBox Practice")]), _vm._v(" "), _c('p', {}, [_vm._v("Connecting Healthcare Professionals to their patients. Move your practice into the digital age. Join the LogBox community today.")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-default",
    attrs: {
      "to": "/practice"
    }
  }, [_vm._v("Learn More")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 grey-3"
  }, [_c('div', {
    staticClass: "p-a-lg"
  }, [_c('h3', {
    staticClass: "m-t-0 m-b"
  }, [_vm._v("LogBox Academic")]), _vm._v(" "), _c('p', {}, [_vm._v("A logbook and electronic portfolio for Academic Registrars, Supervisors and Heads of Departments.")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary",
    attrs: {
      "to": "/signup"
    }
  }, [_vm._v("Sign Up Now")])], 1)])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ae91809e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/brochure/Academic.vue
// module id = 670
// module chunks = 5